import './AboutUs.css'

function AboutUs() {
  return (
    <section id="about" className="about-section">
      <h2 className="about-title">WHY YOU'LL LOVE HAVING<br />US ON YOUR TEAM</h2>
      <div className="about-title-line"></div>

      {/* Feature 01 */}
      <div className="about-feature">
        <span className="feature-number left">01</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Built by Wedding Pros, For Real Couples</h3>
          <div className="feature-text">
            <p>Behind the scenes of this platform is a team who's lived through hundreds of wedding days. We've seen what works, what couples forget, and the little things that save the day. That experience is baked right into your planning hub — so every checklist, reminder, and tip feels less like a random template and more like having a calm, seasoned coordinator at your side.</p>
            <p><strong>Right now, all our core tools are free and fully functional.</strong> Start planning your wedding today with our complete suite of free tools — no credit card required, no hidden fees.</p>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-illustration">
          <img src="/img/mujerTomando.png" alt="Wedding professional" className="feature-img" />
        </div>
      </div>

      {/* Feature 02 */}
      <div className="about-feature">
        <span className="feature-number right">02</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Stay on Top of Your Budget</h3>
          <div className="feature-text">
            <p>Money talks, and weddings make it shout. With clear overviews and gentle nudges, you'll always know what's been covered and what's coming up next. Think of it as having someone in your corner keeping the numbers neat, so you can focus on the fun.</p>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-illustration">
          <img src="/img/TelefonoConBudget.png" alt="Stay on top of your budget" className="feature-img feature-img-phone" />
        </div>
      </div>

      {/* Feature 03 */}
      <div className="about-feature about-feature--with-below-image about-feature--content-full">
        <span className="feature-number left">03</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Guest List, Tamed</h3>
          <div className="feature-text">
            <p>RSVPs, plus-ones, dietary quirks — they all have a home here. Instead of scattered notes and family group chats, you'll see the full picture unfold in one tidy place. It's like having a personal assistant who quietly keeps track so you don't have to.</p>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-image-below">
          <img src="/img/MonitorWeddinGuest.png" alt="Guest list management" className="feature-img feature-img-monitor" />
        </div>
      </div>

      {/* Feature 04 */}
      <div className="about-feature">
        <span className="feature-number right">04</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Vendors at Your Fingertips</h3>
          <div className="feature-text">
            <p>From contracts to phone numbers, everything about your suppliers lives together where you can actually find it. No digging through old emails when you need to confirm delivery times — just the calm reassurance of knowing it's all right there.</p>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-illustration"></div>
      </div>

      {/* Feature 05 */}
      <div className="about-feature about-feature--with-below-image">
        <span className="feature-number left">05</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Keep It All in One Place</h3>
          <div className="feature-text">
            <p>As you move through your planning, see everything come together in one hub — tasks, guests, vendors, timelines — all aligned and organised. It's the kind of clarity that makes you exhale and realise, yes, this is under control.</p>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-illustration">
          <img src="/img/copaDeVino.png" alt="Keep it all in one place" className="feature-img" />
        </div>
        <div className="feature-image-below">
          <img src="/img/LaptopDashboard.png" alt="Dashboard en un solo lugar" className="feature-img feature-img-laptop" />
        </div>
      </div>

      {/* Feature 06 */}
      <div className="about-feature">
        <span className="feature-number right">06</span>
        <div className="feature-content">
          <h3 className="feature-subtitle">Celebrate Without the Chaos</h3>
          <div className="feature-text">
            <p>By the time your big day rolls around, you'll have:</p>
            <ul className="feature-list">
              <li>All your wedding info in one organised, calm, easy-to-use hub.</li>
              <li>No frantic searching through group chats.</li>
              <li>More time for champagne, less time for spreadsheets.</li>
            </ul>
          </div>
          <div className="feature-wavy-line"></div>
        </div>
        <div className="feature-illustration">
          <img src="/img/chicoTomando.png" alt="Celebrate without the chaos" className="feature-img" />
        </div>
      </div>

      {/* Unfiltered Promise Section */}
      <div className="unfiltered-promise">
        <img src="/img/2Copas.png" alt="The Unfiltered Promise" className="promise-img" />
        <p className="promise-title">THE UNFILTERED PROMISE:</p>
        <p className="promise-text">To hold space for the beautiful in-between.</p>
      </div>
    </section>
  )
}

export default AboutUs
